import env from '../env';

const { dwf_api_endpoint } = env;

export { dwf_api_endpoint };
